function MartimeStudies() {
  return (
    <>
    <div className="service-title text-green-38B652 font-700 mb-3">MARITIME STUDIES</div>
              <div className="service-box mb-5 mb-sm-4">There are currently no maritime studies available.</div>

             
    </>
  )
}

export default MartimeStudies;